import React from 'react';
import PropTypes from 'prop-types';
var MarketplaceComparisonTableContext = /*#__PURE__*/React.createContext({
  attributionTopic: undefined
});
/**
 * Puts attributionTopic value into context for the page that is rendering this document.
 * This `Provider` is just a helper.
 */

var MarketplaceComparisonTableContextProvider = function MarketplaceComparisonTableContextProvider(_ref) {
  var attributionTopic = _ref.attributionTopic,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(MarketplaceComparisonTableContext.Provider, {
    value: {
      attributionTopic: attributionTopic
    }
  }, children);
};

MarketplaceComparisonTableContextProvider.propTypes = {
  attributionTopic: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
/**
 * Pulls attributionTopic value from context for the page that is rendering this document.
 */

var MarketplaceComparisonTableContextConsumer = function MarketplaceComparisonTableContextConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(MarketplaceComparisonTableContext.Consumer, null, function (_ref3) {
    var attributionTopic = _ref3.attributionTopic;
    return children({
      attributionTopic: attributionTopic
    });
  });
};

MarketplaceComparisonTableContextConsumer.propTypes = {
  children: PropTypes.func.isRequired
};
export default MarketplaceComparisonTableContext;
export { MarketplaceComparisonTableContextProvider, MarketplaceComparisonTableContextConsumer };